import React, { useCallback, useEffect, useState } from 'react';
import api from '../../api/axios';

function when(value) {
  if (!value) return '—';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '—' : date.toLocaleString('nl-NL');
}

export default function ClientRuntimeErrorsPanel() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [available, setAvailable] = useState(true);

  const load = useCallback(async () => {
    try {
      const response = await api.get('/operations/super-admin/client-errors?limit=20');
      setItems(Array.isArray(response.data?.items) ? response.data.items : []);
      setAvailable(true);
    } catch (error) {
      if ([401, 403].includes(error.response?.status)) setAvailable(false);
      else console.warn('[ClientRuntimeErrorsPanel] unavailable:', error.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);
  if (!available) return null;

  return (
    <section className="rounded-xl border bg-white overflow-hidden">
      <div className="flex items-center justify-between gap-3 border-b px-5 py-4">
        <div><h2 className="font-semibold text-gray-900">Frontend runtime errors</h2><p className="text-sm text-gray-500">Privacy-safe client crashes met support-ID, route en build.</p></div>
        <button onClick={load} className="rounded-lg border px-3 py-1.5 text-sm font-medium text-gray-700">Vernieuwen</button>
      </div>
      {loading ? <div className="p-5 text-sm text-gray-500">Frontend errors laden…</div> : items.length === 0 ? <div className="p-5 text-sm text-gray-500">Geen recente frontendcrashes geregistreerd.</div> : (
        <div className="divide-y">
          {items.map((item) => <div key={item.errorId} className="grid gap-2 px-5 py-4 text-sm lg:grid-cols-[180px_180px_1fr_150px]">
            <div><span className="block text-xs text-gray-400">Fout-ID</span><code className="text-xs text-gray-700">{item.errorId}</code></div>
            <div><span className="block text-xs text-gray-400">Route</span><span className="font-medium text-gray-800">{item.routeType || '—'}</span></div>
            <div className="min-w-0"><span className="block text-xs text-gray-400">Fout</span><span className="block truncate font-medium text-gray-900">{item.errorName || 'Error'}: {item.message || 'Client render error'}</span><span className="mt-1 block truncate text-xs text-gray-400">Build: {item.buildId || 'onbekend'}</span></div>
            <div><span className="block text-xs text-gray-400">Tijdstip</span><span className="text-gray-600">{when(item.createdAt)}</span></div>
          </div>)}
        </div>
      )}
    </section>
  );
}
